import cn from 'clsx';
import type {MouseEvent, ReactNode} from 'react';

const variants = {
    outline:
        'border-2 border-primary bg-transparent px-4 py-2 text-16 leading-6 tracking-button text-primary dark:border-romance dark:text-romance',
    solid: 'min-h-12 gap-3 whitespace-nowrap bg-romance px-6 py-3 text-16 text-primary-inverse tracking-button',
};

export type PillButtonVariant = keyof typeof variants;

interface PillButtonProps {
    children: ReactNode;
    onClick?: (event: MouseEvent) => void;
    className?: string;
    variant?: PillButtonVariant;
}

const PillButton = ({children, onClick, className, variant = 'outline'}: PillButtonProps) => (
    <button
        type='button'
        onClick={onClick}
        className={cn(
            'flex w-full cursor-pointer items-center justify-center rounded-full',
            variants[variant],
            className
        )}
    >
        {children}
    </button>
);

export default PillButton;
